<template>
  <tr class="text-left">
        <td class="crew-name-cell"><p label="Crew Name / Number">{{crew.name}}</p></td>
        <td class="crew-lead-name-cell"><p label="Crew Lead Name">{{crew.crewLead.firstName + " " + crew.crewLead.lastName}}</p></td>
        <td class="crew-lead-phone-cell"><p label="Crew Lead Contact">{{crew.crewLead.phoneNumber}}</p></td>
        <td class="crew-lead-email-cell"><p label="Crew Lead Contact">{{crew.crewLead.email}}</p></td>
        <td class="text-right">
            <div v-if="this.userRole !=='Sub Foreman'">
              <v-icon color="error"
                      @click="showDeleteDialog = true">
                mdi-trash-can-outline
              </v-icon>
            </div>
        </td>
          <template>
            <v-row justify="center">
              <v-dialog v-model="showDeleteDialog" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline pt-1 pr-1">
                    Confirm Delete
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showDeleteDialog = false"><v-icon>close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text class="pb-1"> Are you sure you remove this crew?</v-card-text>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn outlined color="error" @click="remove(crew)">Remove</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
    </tr>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'checklist-crew-details',
  props: {
    crew: {
      type: Object,
      required: true
    },
    selectedCrews: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    showDeleteDialog: false,
    crewsArray: []
  }),

  methods: {
    ...mapActions({
      removeCrew: 'workOrderTask/removeCrew'
    }),
    remove (crew) {
      if (this.selectedCrewArray != null) {
        let crewToRemove = {}
        crewToRemove.crewId = crew.id
        crewToRemove.taskId = this.task.id
        this.removeCrew(crewToRemove)
        this.selectedCrewArray.splice(this.selectedCrewArray.indexOf(crew), 1)
        this.selectedCrewArray = [...this.selectedCrewArray]
      }
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      userRole: 'user/role'
    }),

    selectedCrewArray: {
      get () {
        return this.crewsArray
      },
      set () {
        this.crewsArray = this.selectedCrews
      }
    }
  }
}
</script>
<style scoped>
  @media only screen and (max-width: 720px) {
    .crew-lead-phone-cell,
    .crew-lead-email-cell {
      display: none;
    }
    .crew-name-cell {
      padding-left: 0;
    }
  }
</style>
